import { createAction, props } from "@ngrx/store";


export enum AttributeValueTypes {
    RetrieveDocumentAttributeValueType = '[Attribute Value API] Attribute Value API Success',
    InvokeDocumentAttributeValueType = '[Attribute Value API] Invoke API',
}

export const retrieveDocumentAttributeValuesList = createAction(AttributeValueTypes.RetrieveDocumentAttributeValueType, props<{ currentattributevalue: { controlData: string; selectControl: string; } }>());
export const invokeDocumentAttributeValueApi = createAction(AttributeValueTypes.InvokeDocumentAttributeValueType, props<{ searchtext: string, documentId: string, currentpage: number, pagesize: number, dbname: string }>());
